<template>
  <div class="header">
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container-fluid">
        <li>
          <router-link to="/">
            <img
              alt="LES CEO – coaching en capital intérieur et pilotage du système nerveux pour entrepreneurs, dirigeants, entreprises"
              src="../assets/svg/logo.svg" />
          </router-link>
        </li>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNavDropdown">
          <ul class="navbar-nav">
            <li class="nav-item">
              <router-link to="/" class="nav-link">Home</router-link>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                Services
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <li>
                  <router-link to="/entrepreneuriat" class="dropdown-item">Les Entrepreneuses/Entrepreneurs
                  </router-link>
                </li>
                <li>
                  <router-link to="/entreprise" class="dropdown-item">Entreprise</router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <router-link to="/a-propos" class="nav-link">A propos</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
</script>

<style lang="scss" scoped>
  @import "bootstrap/scss/bootstrap";

  .header {
    position: sticky;
    z-index: 99;
    top: 0px;
    background-color: #FCFAF8;


    @media screen and (min-width: 993px) {
      margin: auto;
    }


    .container-fluid {
      img {
        height: 70px;
        width: 200px;
      }
    }

    .navbar {
      font-size: 18px;
      z-index: 100;
      width: 100%;
      margin: auto;
      padding: 0px;

      .navbar-nav {
        width: 100%;
        justify-content: space-evenly;
        display: flex;
        align-items: center;

        .nav-link {
          color: black;

          &:hover {
            color: #0A6973;
          }

        }

        .dropdown-item {
          &:hover {
            color: #0A6973;
            background: none !important;

          }

          &:active {
            background: none !important;
          }
        }

        .show {
          border: none !important;
          box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
          background: #FCFAF8;
          

          @media screen and (max-width: 480px) {
            text-align: center;
          }
        }
      }
    }
  }
</style>